import React from 'react';

/* ***********************
**   Import Material-UI
*********************** */
import Grid from '@material-ui/core/Grid'


import tempImage from '../../img/logo.png'

const Card = (props) =>{

    return(
        <Grid
            md={6}
            xs={12}
            className='SCB---cards'
        >
            <div>
                <img src={props.imgLink} />
                <h3>{props.cardTitle}</h3>
                <h3 className={props.extraClass}>{props.subTitle}</h3>
            </div>
        </Grid>
    );
}
export default Card;